import styled from '@emotion/styled';
import { screenSizes } from '../Literals';

export const HomeComponent = styled.div`
  background-color: white;
  border-radius: 12px;
  max-width: 80vw;
  padding: 1.1rem;
  margin: 0 auto;
  .admin {
    width: 80vw;
    padding: 1.1rem;
    button {
      margin: 5px !important;
    }
    h2 {
      padding-bottom: 20px;
    }
  }

  .main {
    display: flex;
  }

  .buttons {
    text-align: center;
  }

  .title {
    color: #2596c2;
    font-size: 2.5rem;
  }

  .button {
    background-color: #2596c2;
    border-radius: 0.6rem;
    color: white;
    display: flex;
    margin: 1rem auto;
    max-width: 300px;
    height: 47px;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    text-align: center;
    text-decoration: none;
    transition: 300ms;
    &:hover {
      background-color: black;
    }
  }
  .link {
    text-align: center;
    border-top: 0.5px solid lightgray;
    padding: 20px 0 5px 0;
    margin: 10px 0 0 0;
    align-self: end;
    color: gray;
    cursor: pointer;
  }

  .PublicHome {
    --home-accent: #2596c2;
    --home-ink: #1a2a33;
    --home-muted: #5d6b73;
    --home-line: #d7e3ea;
    --home-wash: #f3f8fb;

    background: radial-gradient(circle at top right, rgba(37, 150, 194, 0.12), transparent 42%),
      linear-gradient(180deg, #f8fbfd 0%, #ffffff 48%, #ffffff 100%);
    border-radius: 22px;
    padding: 28px 32px 36px;
    color: var(--home-ink);

    .title {
      color: var(--home-accent);
      font-size: clamp(2rem, 4vw, 2.6rem);
      margin: 0.15rem 0 0.5rem;
      line-height: 1.15;
    }
  }

  .PublicHome__header {
    margin-bottom: 1.75rem;
  }

  .PublicHome__brand {
    margin: 0;
    color: var(--home-accent);
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .PublicHome__intro {
    margin: 0;
    max-width: 36rem;
    color: var(--home-muted);
    font-size: 1.05rem;
    line-height: 1.45;
  }

  .PublicHome__services {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
  }

  .PublicHome__service {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 1.1rem;
    border: 1px solid var(--home-line);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.88);
    color: inherit;
    text-decoration: none;
    transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease;

    &:hover,
    &:focus-visible {
      border-color: var(--home-accent);
      background: var(--home-wash);
      transform: translateY(-1px);
      outline: none;
    }
  }

  .PublicHome__service-copy {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
  }

  .PublicHome__service-title {
    font-size: 1.08rem;
    font-weight: 700;
    color: var(--home-ink);
  }

  .PublicHome__service-description {
    font-size: 0.95rem;
    line-height: 1.4;
    color: var(--home-muted);
  }

  .PublicHome__service-arrow {
    flex-shrink: 0;
    color: var(--home-accent);
    font-size: 1.25rem;
    font-weight: 600;
  }

  .PublicHome__habeas {
    margin-top: 2.25rem;
    padding: 1.35rem 1.4rem;
    border: 2px solid var(--home-accent);
    border-radius: 16px;
    background: linear-gradient(180deg, rgba(37, 150, 194, 0.1) 0%, rgba(37, 150, 194, 0.04) 100%);

    h2 {
      margin: 0 0 0.75rem;
      color: var(--home-accent);
      font-size: 1.35rem;
      font-weight: 800;
      letter-spacing: 0.02em;
      text-transform: uppercase;
    }

    p {
      margin: 0 0 0.85rem;
      color: var(--home-ink);
      font-size: 0.98rem;
      line-height: 1.55;
    }

    p:last-child {
      margin-bottom: 0;
    }

    a {
      color: var(--home-accent);
      font-weight: 700;
      text-decoration: underline;
    }
  }

  .StaffHome {
    --home-accent: #2596c2;
    --home-ink: #1a2a33;
    --home-muted: #5d6b73;
    --home-line: #d7e3ea;
    --home-wash: #f3f8fb;

    background: radial-gradient(circle at top left, rgba(37, 150, 194, 0.14), transparent 40%),
      linear-gradient(180deg, #f7fafc 0%, #ffffff 45%, #ffffff 100%);
    border-radius: 22px;
    padding: 28px 32px 36px;
    color: var(--home-ink);

    .title {
      color: var(--home-accent);
      font-size: clamp(2rem, 4vw, 2.6rem);
      margin: 0.15rem 0 0.5rem;
      line-height: 1.15;
    }
  }

  .StaffHome__header {
    margin-bottom: 1.75rem;
  }

  .StaffHome__brand {
    margin: 0;
    color: var(--home-accent);
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .StaffHome__intro {
    margin: 0;
    max-width: 40rem;
    color: var(--home-muted);
    font-size: 1.05rem;
    line-height: 1.45;

    strong {
      color: var(--home-ink);
      font-weight: 700;
    }
  }

  .StaffHome__empty {
    margin: 0;
    padding: 1.1rem 1.2rem;
    border: 1px dashed var(--home-line);
    border-radius: 14px;
    color: var(--home-muted);
    background: rgba(255, 255, 255, 0.8);
  }

  .StaffHome__groups {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .StaffHome__group-title {
    margin: 0 0 0.7rem;
    color: var(--home-muted);
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .StaffHome__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .StaffHome__tile {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.85rem;
    min-height: 108px;
    padding: 1.05rem 1.1rem;
    border: 1px solid var(--home-line);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.92);
    color: inherit;
    text-decoration: none;
    transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease,
      box-shadow 180ms ease;

    &:hover,
    &:focus-visible {
      border-color: var(--home-accent);
      background: var(--home-wash);
      box-shadow: 0 8px 20px rgba(37, 150, 194, 0.08);
      transform: translateY(-2px);
      outline: none;
    }
  }

  .StaffHome__tile-copy {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    min-width: 0;
  }

  .StaffHome__tile-title {
    font-size: 1.08rem;
    font-weight: 700;
    color: var(--home-ink);
  }

  .StaffHome__tile-description {
    font-size: 0.92rem;
    line-height: 1.4;
    color: var(--home-muted);
  }

  .StaffHome__tile-arrow {
    flex-shrink: 0;
    margin-top: 0.1rem;
    color: var(--home-accent);
    font-size: 1.2rem;
    font-weight: 600;
  }

  .StaffHome__admin {
    display: block;
    width: 100%;
    margin-top: 1.75rem;
    padding: 0.95rem 1rem;
    border: 0;
    border-top: 1px solid var(--home-line);
    border-radius: 0;
    background: transparent;
    color: var(--home-muted);
    font: inherit;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: color 160ms ease;

    &:hover,
    &:focus-visible {
      color: var(--home-accent);
      outline: none;
    }
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    justify-content: center;
    max-width: 100vw;
    .PublicHome,
    .StaffHome {
      padding: 18px 14px 28px;
      width: 100%;
    }
    .StaffHome__grid {
      grid-template-columns: 1fr;
    }
    .main {
      display: block;
    }
    .content {
      width: 100%;
      padding: 20px 0 0 0;
    }
  }
`;
